import axios from 'axios';

// إنشاء نسخة مخصصة من axios
const apiClient = axios.create({
    // baseURL فارغ تماماً. هذا يجبر axios على استخدام الروابط النسبية.
    baseURL: '',

    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
});

// استخدام interceptor لإضافة بادئة API بشكل يدوي ومضمون
apiClient.interceptors.request.use(config => {
    // هذا يضمن أن كل طلب سيبدأ بـ /api/v1
    config.url = `/api/v1${config.url}`;
    return config;
}, error => {
    return Promise.reject(error);
});

export default apiClient;